import type {
  ApplyReportTemplateResponse,
  ReportTemplateRequest,
  ReportTemplateResponse,
  ReportTemplatesResponse,
} from "types/ReportTemplates.type";

import { api } from "utils/api";

export const getReportTemplates = () => api.get<ReportTemplatesResponse>("/report-template");

export const addReportTemplate = (data: ReportTemplateRequest) =>
  api.post<ReportTemplateResponse>("/report-template", data);

export const getReportTemplate = (id: string) => api.get<ReportTemplateResponse>(`/report-template/${id}`);

export const editReportTemplate = (id: string, data: ReportTemplateRequest) =>
  api.put<ReportTemplateResponse>(`/report-template/${id}`, data);

export const deleteReportTemplate = (id: string) => api.delete<void>(`/report-template/${id}`);

export const applyReportTemplate = (id: string, input: string) =>
  api.post<ApplyReportTemplateResponse>(`/report-template/${id}/apply`, { input });
